
/**
 * 콘텐츠 타입
 */
export type CreateCourseDraft201LocalizedSectionsItemLecturesItemContentType = typeof CreateCourseDraft201LocalizedSectionsItemLecturesItemContentType[keyof typeof CreateCourseDraft201LocalizedSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201LocalizedSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
